import {Box, Card, CardActionArea, CardContent, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import PieChart from '@user-components/PieChart';
import {HorizontalBar} from "react-chartjs-2";
import { useHistory } from "react-router-dom";
import AuthProvider from "@user-provider/AuthProvider";

export default function BalancePie(props) {
    const classes = useStyles();
    const history = useHistory()

    const ableClick = true !== props.clickDisabled
    const { id, bandRangeData, isEEG } = props.measureResult
    const labels = ['δ','θ','α','SMR','β', 'βM', 'βh']

    const handler = () => {
        if(AuthProvider.canViewMeasureDetail() && ableClick){
            history.push('/measureDetail/' + id + '/balanceBrain');
        }
    }

    // 차이값 계산
    const ch1 = bandRangeData.ch1.map(v => parseFloat(v));
    const ch2 = bandRangeData.ch2.map(v => parseFloat(v));
    const leftTotal = ch1.reduce((sum, v) => sum + v, 0);
    const rightTotal = ch2.reduce((sum, v) => sum + v, 0);
    const rawDiff = parseFloat((rightTotal - leftTotal).toFixed(2));
    const bandDiff = parseFloat((ch2[0] - ch1[0]).toFixed(2));

    return (
        <Box className={classes.root}>
            <Card className={classes.card}>
                <CardContent>
                    <Typography variant={'subtitle1'} className={classes.title}>
                        좌우뇌 균형상태
                    </Typography>

                    <CardActionArea onClick={handler}>
                        {'yes' === isEEG &&
                            <Box mt={3} mb={2} style={{marginTop: 40}}>
                            <Grid container justify={'center'}>
                                {labels.map((label, index) => {
                                    const c1 = bandRangeData.ch1[index];
                                    const c2 = bandRangeData.ch2[index];
                                    const total = parseFloat(c1) + parseFloat(c2)
                                    const ch1Percent = 0 === total ? 50 : Math.floor(c1 / total * 100)
                                    const ch2Percent = 0 === total ? 50 : Math.floor(c2 / total * 100)

                                    return (
                                        <Grid item key={Math.random() * 100}>
                                            <PieChart
                                                key={Math.random()}
                                                defaultData={[ch2Percent, ch1Percent]}
                                                labels={['', '']}
                                                height={110}
                                                width={80}
                                                title={label}
                                                xLabelDisplay={true}
                                                useColorIndex={true}
                                                colors={['#BEF3B0', '#FF00A5']}/>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Box>
                        }

                        {'yes' !== isEEG &&
                        <Box display={'flex'} minHeight={200}>
                            <Box m="auto">
                                <Typography variant="h6" style={{color:'#999'}}>
                                    뇌기능(EEG) 측정이 필요합니다.
                                </Typography>
                            </Box>
                        </Box>
                        }
                    </CardActionArea>

                    {'yes' === isEEG &&
                    <Box style={{marginTop: 20}}>
                        <Box mb={1} display={'flex'} alignItems={'center'}>
                            <Typography variant={'subtitle2'} className={classes.diffLabel}>RAW</Typography>
                            <Box flex={1}>
                                <DiffBarChart
                                    labels={['RAW']}
                                    data={[rawDiff]}
                                    colors={[rawDiff < 0 ? '#60C3F7' : '#A9D8AA']}
                                />
                            </Box>
                        </Box>
                        <Box display={'flex'} alignItems={'center'}>
                            <Typography variant={'subtitle2'} className={classes.diffLabel}>BAND</Typography>
                            <Box flex={1}>
                                <DiffBarChart
                                    labels={['δ']}
                                    data={[bandDiff]}
                                    colors={[bandDiff < 0 ? '#60C3F7' : '#A9D8AA']}
                                />
                            </Box>
                        </Box>

                    </Box>
                    }
                </CardContent>
            </Card>
        </Box>
    )
}

function DiffBarChart({labels, data, colors}) {
    const chartData = {
        labels,
        datasets: [{
            data,
            backgroundColor: colors,
            borderColor: colors,
            borderWidth: 1,
        }]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false,
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    const val = tooltipItem.xLabel;
                    if (val < 0) return `좌뇌 우세: ${Math.abs(val)}`;
                    return `우뇌 우세: ${val}`;
                }
            }
        },
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    display: true,
                    color: 'rgba(0,0,0,0.08)',
                    zeroLineColor: '#333',
                    zeroLineWidth: 2,
                },
                ticks: {
                    fontColor: '#666',
                    fontSize: 11,
                    min: -50,
                    max: 50,
                    stepSize: 25,
                    callback: function (value) {
                        if (value === 0) return '0';
                        return value > 0 ? `+${value}` : `${value}`;
                    }
                },
            }],
            yAxes: [{
                display: false,
                barPercentage: 0.6,
                categoryPercentage: 0.8,
            }]
        }
    };

    return (
        <Box style={{height: 50, position: 'relative'}}>
            <HorizontalBar
                key={Math.random()}
                data={chartData}
                options={options}
            />
        </Box>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
    },
    title: {
        fontWeight: 'bold',
        paddingLeft: 15,
        marginBottom: 0
    },
    card: {
        border: "none",
        boxShadow: "none",
        padding: 0
    },
    diffLabel: {
        fontWeight: 'bold',
        color: '#555',
        marginBottom: 0,
        paddingLeft: 4,
        fontSize: 13,
        minWidth: 50,
    },
}));
